/**
 * MainNav big menu for desktop
 */
(function($) {
  "use strict";

  $(window).ready(init);

  // Constants
  var CONTAINER_SEL = "#block-navigationprincipale";
  var ITEM_SEL = ".menu-level-0 > .menu-item--expanded";
  var DROPDOWN_SEL = ".menu-level-0 > .menu-item > .menu-dropdown";
  var SUBITEM_SEL = ".menu-item";
  var SUBDROPDOWN_SEL = ".menu-dropdown:not(.menu_link_content)";
  var SUBITEM_EXPANDED_SEL = ".menu-level-1 .menu-item--expanded";
  var DIV_HEIGHT = "#block-navigationprincipale .menu_link_content";

  var LV1AND2_SUBITEM_SEL = "";
  LV1AND2_SUBITEM_SEL += CONTAINER_SEL + " .menu-level-1 " + SUBITEM_SEL;
  LV1AND2_SUBITEM_SEL += ", ";
  LV1AND2_SUBITEM_SEL += CONTAINER_SEL + " .menu-level-2 " + SUBITEM_SEL;

  var MENU_0 = '.menu-level-0';
  var MENU_ITEM = '.menu-item';
  var MENU_DROPDOWN_0 = '.menu-dropdown-0.menu_link_content';
  var MENU_DROPDOWN_1 = '.menu-dropdown-1.menu_link_content';
  var MENU_DROPDOWN_2 = '.menu-dropdown-2.menu_link_content';

  /**
   * Init
   */
  function init() {
    var container = $(CONTAINER_SEL);
    var lv1and2_subitems = $(LV1AND2_SUBITEM_SEL);
    if (container.length === 0 || lv1and2_subitems.length === 0) {
      return;
    }

    // Initialize height for menu
    initHeight();
    // close on init
    openInit(container);
    // Assign mouse events
    container.hoverIntent({
      over: lv0_item_mouse_enter,
      out: lv0_item_mouse_leave,
      selector: ITEM_SEL
    });
    lv1and2_subitems.hoverIntent({
      over: lv1and2_subitem_mouse_enter
    });
  }

  /**
   * (Re)sets dropdown state to closed.
   */
  function openInit(container) {
    // close all first level
    container.find(ITEM_SEL).attr("aria-expanded","false");
    container.find(DROPDOWN_SEL).attr("aria-hidden", "true");
    // close all sub levels except first one
    container.find(SUBITEM_SEL).attr("aria-expanded","false");
    container.find(SUBDROPDOWN_SEL).attr("aria-hidden", "true");
    $(ITEM_SEL).each(function () {
      $(this).find(SUBITEM_SEL).eq(0).attr("aria-expanded","true");
      $(this).find(SUBITEM_SEL).eq(0).find(SUBDROPDOWN_SEL).eq(0).attr("aria-hidden", "false");
    })
    $(SUBITEM_EXPANDED_SEL).each(function () {
      $(this).find(".menu-item").eq(0).attr("aria-expanded","true");
      $(this).find(".menu-item").eq(0).find(SUBDROPDOWN_SEL).attr("aria-hidden", "false");
    })
  }

  /**
   * Mouse enters ITEM_SEL event handler.
   *
   * open a menu on mouse enter
   */
  function lv0_item_mouse_enter() {
    var el = $(this);
    var panel = el.children(DROPDOWN_SEL);
    el.attr("aria-expanded", "true");
    panel.attr("aria-hidden", "false");
  };

  /**
   * Mouse leaves ITEM_SEL event handler.
   *
   * close a menu on mouse leave
   */
  function lv0_item_mouse_leave() {
    var el = $(this);
    var panel = el.children(DROPDOWN_SEL);
    el.attr("aria-expanded", "false");
    panel.attr("aria-hidden", "true");
    openInit($(CONTAINER_SEL));
  };

  /**
   * Mouse enters level 1+ SUBITEM_SEL event handler.
   *
   * open a sub menu on mouse enter end close other sub menu
   */
  function lv1and2_subitem_mouse_enter() {
    var el = $(this);
    var panel = el.children(SUBDROPDOWN_SEL);
    el.attr("aria-expanded", "true");
    panel.attr("aria-hidden", "false");
    el.siblings().attr("aria-expanded", "false");
    el.siblings().children(SUBDROPDOWN_SEL).attr("aria-hidden", "true");
  };

  /**
   * Applies dynamic equal-height on dropdown zone.
   */
  function initHeight() {
    $(MENU_0).children(MENU_ITEM).each(function(index, menu_item) {
      var TAB_HEIGHT_GLOBAL = [];
      var HEIGHT = 0;

      // Here we determine which submenu has the highest height to set it on all menu
      TAB_HEIGHT_GLOBAL = TAB_HEIGHT_GLOBAL.concat(determineSubMenuHeight(menu_item, MENU_DROPDOWN_0))
                                           .concat(determineSubMenuHeight(menu_item, MENU_DROPDOWN_1))
                                           .concat(determineSubMenuHeight(menu_item, MENU_DROPDOWN_2));

      // After have all the height, we grab the max
      for (var i in TAB_HEIGHT_GLOBAL) if(TAB_HEIGHT_GLOBAL[i]>HEIGHT) HEIGHT=TAB_HEIGHT_GLOBAL[i];

      // Finally, we set the height on menu
      setHeightOnMenu(menu_item, HEIGHT)

    })
  }

  // Determine height of the submenu
  // We create an array and push all the height in it, and get the max
  function determineSubMenuHeight(menu_item, menu_dropdown) {
    var TAB_HEIGHT_SUBMENU = [];
    var MAX_HEIGHT = 0;

    var THIS_MENU_DROPDOWN = $(menu_item).find(menu_dropdown);
    $(THIS_MENU_DROPDOWN).each(function(index, item) {
      TAB_HEIGHT_SUBMENU.push($(item).height())
    });

    for (var i in TAB_HEIGHT_SUBMENU) if(TAB_HEIGHT_SUBMENU[i]>MAX_HEIGHT) MAX_HEIGHT=TAB_HEIGHT_SUBMENU[i];

    return MAX_HEIGHT;
  }

  function setHeightOnMenu(menu_item, height) {
    $(menu_item).find(MENU_DROPDOWN_0).height(height);
    $(menu_item).find(MENU_DROPDOWN_1).height(height);
    $(menu_item).find(MENU_DROPDOWN_2).height(height);
  }


})(jQuery);
